/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import {Router} from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-forgot-username-password-dialog',
  templateUrl: './forgot-username-password-dialog.component.html'
})
export class ForgotUsernamePasswordDialogComponent {
  
  @Output()
  resetEvent = new EventEmitter<string>();
  
  mEmailAddress = "";
  
  constructor(
    
  ) { }
  
  show(): void {
    this.mEmailAddress = "";
    $("#forgotPasswordModal").modal('show');
  }
  
  nextClicked(): void {
    console.log("Next Clicked! - Email Address: " + this.mEmailAddress);
    this.resetEvent.emit(this.mEmailAddress);
  }

}
